module.exports = __webpack_public_path__ + "img/fritschi_3.405f7c71.jpg";